/**
 * Calculate total years of experience including months
 * @param {number} startMonth - Starting month (1-12, where 1 = January)
 * @param {number} startYear - Starting year
 * @returns {number} Total experience in years with decimal precision (e.g., 4.6)
 */
export const calculateTotalExperience = (startMonth, startYear) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-11, so add 1
  const currentYear = currentDate.getFullYear();
  
  // Calculate total months
  const totalMonths = (currentYear - startYear) * 12 + (currentMonth - startMonth);
  
  // Convert to years with decimal precision
  const totalYears = totalMonths / 12;
  
  // Round to 1 decimal place
  return Math.round(totalYears * 10) / 10;
};
